import { cssVar as r, defineStyle as a, defineStyleConfig as l } from "@chakra-ui/styled-system";
const e = r("skeleton-start-color"), o = r("skeleton-end-color"), s = a({
  [e.variable]: "colors.gray.100",
  [o.variable]: "colors.gray.400",
  _dark: {
    [e.variable]: "colors.gray.800",
    [o.variable]: "colors.gray.600"
  },
  background: e.reference,
  borderColor: o.reference,
  opacity: 0.7,
  borderRadius: "sm"
}), c = l({
  baseStyle: s
});
export {
  c as skeletonTheme
};
